export const mhStates = [{ value: 'MH', label: 'MH' }]
